import React from "react";
import loader from '../../../../images/loader/loader3.svg';
const SkeletonHexLoader = () => {
  return <img className="animate-pulse h-[610px]" alt={'loader'}   src={loader}/>
};

export default SkeletonHexLoader;
